<template>
    <div id="monthCarousel" class="carousel slide mt-4" data-bs-ride="false">
        <div class="carousel-inner">
            <div v-for="(mes, index) in allMonths" :key="index" :class="['carousel-item', { active: index === 0 }]">
                <div class="text-center">
                    <button class="btn btn-primary" @click="showYearSelector = !showYearSelector">
                        {{ mes.mes }} {{ mes.year }}
                    </button>
                    <div v-if="showYearSelector" class="text-center">
                        <ul class="dropdown-menu show" aria-labelledby="dropdownMenuButton"
                            style="position: absolute; left: 50%; transform: translateX(-55px);">
                            <li v-for="n in 4" :key="n">
                                <button class="dropdown-item" @click="year = 2024 + n">{{ 2024 + n }}</button>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Lun</th>
                                <th scope="col">Mar</th>
                                <th scope="col">Mié</th>
                                <th scope="col">Jue</th>
                                <th scope="col">Vie</th>
                                <th scope="col">Sáb</th>
                                <th scope="col">Dom</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(week, weekIndex) in generateWeeks(mes)" :key="weekIndex">
                                <td v-for="(day, dayIndex) in week" :key="dayIndex" class="text-center">
                                    <button v-if="day" :class="{
                                        //'btn btn-warning': !isDaySelected(day),
                                        'btn btn-success': isDaySelected(day),
                                        'btn btn-outline-secondary': !isDaySelected(day)
                                    }" @click="handleDayClick(day)">
                                        {{ day.slice(-2) }}
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="carousel-controls">
            <button class="carousel-control-prev" type="button" data-bs-target="#monthCarousel" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#monthCarousel" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>
    </div>
</template>

<script>
import * as bootstrap from 'bootstrap'

export default {
    props: {
        fechasDisponibles: Array,
    },
    data() {
        return {
            year: new Date().getFullYear(),
            showYearSelector: false,
            currentMonthIndex: new Date().getMonth()
        };
    },
    computed: {
        allMonths() {
            const meses = [
                'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ];
            return meses.map(mes => ({
                mes,
                year: this.year
            }));
        }
    },
    mounted() {
        const carousel = document.querySelector('#monthCarousel');
        if (carousel) {
            const bsCarousel = new bootstrap.Carousel(carousel, {
                interval: false
            });
            bsCarousel.to(this.currentMonthIndex);
        }
    },
    methods: {
        generateWeeks(mes) {
            const diasEnMes = new Date(mes.year, this.mesNumber(mes.mes) + 1, 0).getDate();
            const primerDiaMes = new Date(mes.year, this.mesNumber(mes.mes), 1).getDay();
            const weeks = [];
            let week = [];
            let primerDia = primerDiaMes === 0 ? 7 : primerDiaMes;

            for (let i = 1; i < primerDia; i++) {
                week.push(null);
            }

            for (let i = 1; i <= diasEnMes; i++) {
                const dia = `${mes.year}-${String(this.mesNumber(mes.mes) + 1).padStart(2, '0')}-${String(i).padStart(2, '0')}`;
                week.push(dia);

                if (week.length === 7) {
                    weeks.push(week);
                    week = [];
                }
            }

            if (week.length) {
                while (week.length < 7) {
                    week.push(null);
                }
                weeks.push(week);
            }
            return weeks;
        },
        mesNumber(mes) {
            const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
            return meses.indexOf(mes);
        },
        handleDayClick(dia) {
            this.$emit('toggle-day', dia);
        },
        isDaySelected(dia) {
            return this.fechasDisponibles.includes(dia);
        }
    }
};
</script>

<style scoped>
.carousel-inner {
    background-color: #ffffff;
    padding: 10px;
    border-radius: 10px;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
    filter: invert(1);
}

.carousel-item {
    transition: transform 0.5s ease-in-out;
}

.carousel-controls {
    position: absolute;
    top: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
}

select {
    max-width: 200px;
}

.custom-select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    border: none;
    padding: 0;
    text-align: center;
    cursor: pointer;
}

.custom-select:focus {
    outline: none;
}

.select-container {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    z-index: 10;
    text-align: center;
}
</style>
